<template>
    <div>
        <public-head title="校派"></public-head>
        <div class="contain">
            <div class="title">{{info.title}}</div>
            <div class="content">
                <p v-html="info.content"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost } from "../../../axios/index";
import PublicHead from "../../../components/publicHead";
export default {
    data() {
        return {
            info: ""
        };
    },
    created() {},
    methods: {
        fetchData() {
            // 获取学校详情数据
            httpPost("/optimi/view", {
                id: this.$route.query.id
            }).then(res => {
               
                if (res.code === 1) {
                    this.info = res.data;
                }
            });
        }
    },
    mounted() {
        this.fetchData();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.contain {
    width: 19.5rem;
    margin: 1.5625rem auto;
    padding-bottom: 1.5625rem;
    color: #2e2f41;
    border-bottom: 0.0625rem solid #dcdcdc;
    margin-top: 46px;
    overflow: hidden;
}

.title {
    font-size: 1.5rem;
}

.content {
    margin-top: 2.375rem;
    font-size: 1rem;
}
</style>

